import styled from 'styled-components';

export const Container = styled.div`
  @page {
    size: 75mm 200mm;
    padding: 10px;
  }
  @media print {
    html,
    body {
      width: 75mm;
      height: 200mm;
      font-family: 'Poppins', sans-serif !important;
    }
    h1 {
      margin-right: auto;
    }
    img {
      width: 70mm;
      height: auto;
    }
  }
`;
